module.exports = __webpack_public_path__ + "static/img/icon_1.e4db1544.png";